function initPartnersCarousel() {
  document.querySelectorAll(".js-partners-carousel:not(.active)").forEach((element) => {
    element.classList.add('active');

    const splide = new Splide(element, {
      type: 'loop',
      drag: 'free',
      gap: '20px',
      perPage: 5,
      rewind: false,
      arrows: false,
      pagination: false,
      accessibility: false,
      slideFocus: false,
      autoScroll: {
        speed: element.getAttribute('data-scrolling-speed'),
      },
      breakpoints: {
        500: { perPage: 2.5 },
        767: { perPage: 3 },
        991: { perPage: 3 },
        1198: { perPage: 4 },
        1440: { perPage: 5 }
      }
    });

    splide.mount(window.splide.Extensions);

    setInterval(() => {
      element.querySelectorAll('.splide__slide a').forEach(a => {
        if (a.getAttribute('tabindex') !== '1') {
          a.setAttribute('tabindex', '1');
        }
      });
    }, 500);
  });
}

document.addEventListener("DOMContentLoaded", initPartnersCarousel);
document.addEventListener('shopify:section:load', initPartnersCarousel);
document.addEventListener('shopify:section:reorder', initPartnersCarousel);
document.addEventListener('shopify:section:select', initPartnersCarousel);
document.addEventListener('shopify:block:select', initPartnersCarousel);
document.addEventListener('shopify:block:deselect', initPartnersCarousel);